import React from 'react';
import EchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/pie';

import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/secondary-school/layoutProps';

import styles from './index.module.scss';

const data = [
  { name: 'ICHK (20%)', value: 20 },
  { name: 'ESF Schools (18%)', value: 18 },
  { name: 'Chinese International School (9%)', value: 9 },
  { name: 'Overseas (7%)', value: 7 },
  { name: 'Creative Secondary School (14%)', value: 14 },
  { name: 'Yew Chung (5%)', value: 5 },
  { name: 'Local Schools (3%)', value: 3 },
  { name: 'Harrow (6%)', value: 6 },
  { name: 'Hong Kong Academy (4%)', value: 4 },
  { name: 'Malvern (7%)', value: 7 },
  { name: 'Other International Schools (7%)', value: 7 },
];

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="secondary-choices-of-past-graduates">
    <h1>舊畢業生的中學選擇</h1>
    <p>
      雖然京斯敦擁有一條龍中學(ICHK)提供優質教學，我們亦支持家長為學生選擇其他中學。我們致力與香港不同中學建立友好夥伴關係，能見證本校畢業生獲這些學校錄取，我們感到非常高興與自豪。我們整理了過去十年京斯敦畢業生入讀中學的數據，詳情請參閱下圖：
    </p>
    <div className={styles.chart}>
      <EchartsCore
        echarts={echarts}
        option={{
          visualMap: {
            show: false,
            inRange: {
              colorLightness: [0, 1],
            },
          },

          series: [
            {
              name: 'Secondary Choices',
              type: 'pie',
              radius: '55%',
              center: ['50%', '50%'],
              data,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
              },
              animationType: 'scale',
              animationEasing: 'elasticOut',
            },
          ],
        }}
      />
    </div>
  </ContentLayout>
);
